import { isPathwayEvolution, pathwayPathLabel } from "./pathway";
/**
 * Steps whose evolution has not loaded (or no longer exists) take
 * `fallbackLabel`, so the chain keeps its shape.
 */
export const evolutionChainSteps = ({ evolutionIds, pathwayPath, resolve, fallbackLabel, }) => evolutionIds.map((id, index) => {
    const evolution = resolve(id);
    const isPathway = evolution ? isPathwayEvolution(evolution) : false;
    return {
        label: evolution?.name ?? fallbackLabel(index),
        detail: isPathway && evolution
            ? pathwayPathLabel(evolution, pathwayPath?.[index])
            : undefined,
        isPathway,
        expired: evolution?.expired ?? false,
    };
});
/**
 * What the chain adds up to: every step's price and matches, summed from the
 * catalogue — the players endpoints do not send them. A repeated evolution
 * counts each time it appears.
 */
export const evolutionChainTotals = ({ evolutionIds, resolve, }) => {
    let coins = 0;
    let points = 0;
    const tokens = {};
    let games = 0;
    for (const id of evolutionIds) {
        const evolution = resolve(id);
        coins += evolution?.cost?.coins ?? 0;
        points += evolution?.cost?.points ?? 0;
        for (const [eventTokenId, amount] of Object.entries(evolution?.cost?.tokens ?? {})) {
            tokens[eventTokenId] = (tokens[eventTokenId] ?? 0) + amount;
        }
        games += evolution?.matches ?? 0;
    }
    return { cost: { coins, points, tokens }, games };
};
//# sourceMappingURL=chain.js.map